import React from "react";
import NimbusLinkCard from "../../../ui-components/nimbus-link-card/nimbus-link-card";

const NimbusTeamsIndex = () => {
  return (
    <div className="flex flex-row flex-wrap h-full items-center justify-center text-center gap-2">
      <NimbusLinkCard
        title={"Finance Team"}
        to={"/nimbus/teams/team_1234"}
        icon="fa-sack-dollar"
      />
      <NimbusLinkCard
        title={"Legal Team"}
        to={"/nimbus/teams/team_5678"}
        icon="fa-balance-scale"
      />
      <NimbusLinkCard
        title={"Design Team"}
        to={"/nimbus/teams/team_91011"}
        icon="fa-paint-brush"
      />
      <NimbusLinkCard
        title={"Team Review"}
        to={"/nimbus/teams/review"}
        icon="fa-search"
      />
    </div>
  );
};

export default NimbusTeamsIndex;
